import produce from 'immer';
import {
  GET_STORE_PICKUP_LOCATIONS_START,
  GET_STORE_PICKUP_LOCATIONS_SUCCESS,
  GET_STORE_PICKUP_LOCATIONS_FAILED,
  SET_NEW_LOCATION_VALUE,
  ADD_STORE_PICKUP_LOCATION_STATUS,
  TRIGGER_STORE_PICKUP_ENABLE,
  ADD_STORE_PICKUP_LOCATION_START,
  ADD_STORE_PICKUP_LOCATION_SUCCESS,
  ADD_STORE_PICKUP_LOCATION_FAILED,
  UPDATE_STORE_PICKUP_LOCATION_START,
  UPDATE_STORE_PICKUP_LOCATION_SUCCESS,
  UPDATE_STORE_PICKUP_LOCATION_FAILED,
  DELETE_STORE_PICKUP_LOCATION_START,
  DELETE_STORE_PICKUP_LOCATION_SUCCESS,
  DELETE_STORE_PICKUP_LOCATION_FAILED,
  GET_STORE_PICKUP_CONFIG_START,
  GET_STORE_PICKUP_CONFIG_SUCCESS,
  GET_STORE_PICKUP_CONFIG_FAILED,
  UPDATE_STORE_PICKUP_CONFIG_START,
  UPDATE_STORE_PICKUP_CONFIG_SUCCESS,
  UPDATE_STORE_PICKUP_CONFIG_FAILED,
  CANCEL_ADD_STORE_PICKUP_LOCATION,
  REMOVE_LOCATION_VALUE
} from '../actions/store_pickup';

import {
  CHANGE_ACTIVE_STORE_SUCCESS,
} from '../actions/user';


const initialState = {
  storePickupLocations: [],
  newStorePickupLocation: {
    status: 1,
    position: 0,
    country_code: 'US',
    hours: [],
    customer_group: [0, 1] //Customer groups 'not logged in', 'general' should be by default
  },
  isAutoEnableStorePickup: false,
  loadingStorePickupLocations: false,
  errorStorePickupLocations: false,
  loadingDeleteStorePickupLocation: false,
  addStorePickupLocationStatus: false,
  loadingAddStorePickupLocation: false,
  loadingUpdateAddStorePickupLocation: false,
  noStorePickupLocations: false,
  isStorePickupEnable: false,
  loadingStorePickupConfig: false
};

const formReducer = produce((state = initialState, action) => {
  switch (action.type) {
    case GET_STORE_PICKUP_LOCATIONS_START: {
      state.errorStorePickupLocations = false;
      state.loadingStorePickupLocations = true;
      break;
    }
    case GET_STORE_PICKUP_LOCATIONS_SUCCESS: {
      const {data} = action;

      state.storePickupLocations = data;
      state.errorStorePickupLocations = false;
      state.loadingStorePickupLocations = false;

      break;
    }
    case GET_STORE_PICKUP_LOCATIONS_FAILED: {
      // const {error} = action;

      state.StorePickupLocations = true;
      state.loadingStorePickupLocations = false;
      break;
    }
    case SET_NEW_LOCATION_VALUE: {
      const {keyName, value} = action;

      if (keyName.includes('_to') || keyName.includes('_from')) {
        const [day, timeRange] = keyName.split('_');

        if (!state.newStorePickupLocation.hours) {
          state.newStorePickupLocation.hours = [
            {
              day,
              [timeRange]: value
            }
          ];
        } else {
          const existHours = state.newStorePickupLocation.hours.filter((item) => item.day === day);

          if (!existHours.length) {
            state.newStorePickupLocation.hours = [
              ...state.newStorePickupLocation.hours,
              {
                day,
                [timeRange]: value
              }
            ];
          } else {
            state.newStorePickupLocation.hours = state.newStorePickupLocation.hours.map((item) => {
              return item.day === day ? {...item, [timeRange]: value} : item;
            });
          }
        }
      } else {
        state.newStorePickupLocation = {...state.newStorePickupLocation, [keyName]: value};
      }

      break;
    }
    case REMOVE_LOCATION_VALUE: {
      const { keyName } = action;
      const [day, timeRange] = keyName.split('_');

      state.newStorePickupLocation.hours = state.newStorePickupLocation.hours.reduce((acc, el) => {
        if (el.day === day) {
          if (el.from && el.to) {
            const updatedDay = { ...el };
            Reflect.deleteProperty(updatedDay, timeRange);
            acc.push(updatedDay);
          }
        } else {
          acc.push(el);
        }

        return acc;
      }, []);

      break;
    }
    case DELETE_STORE_PICKUP_LOCATION_START: {
      state.loadingDeleteStorePickupLocation = true;
      break;
    }
    case DELETE_STORE_PICKUP_LOCATION_SUCCESS: {
      const {id} = action;

      state.storePickupLocations = state.storePickupLocations.filter((location) => location.place_id !== id);
      state.loadingDeleteStorePickupLocation = false;

      break;
    }
    case DELETE_STORE_PICKUP_LOCATION_FAILED: {
      const {error} = action;

      if (error.response.data.status == 404) {
        state.noStorePickupLocations = true;
      }

      state.loadingDeleteStorePickupLocation = false;
      break;
    }
    case ADD_STORE_PICKUP_LOCATION_STATUS: {
      const {status} = action;
      state.storePickupLocationStatus = status;
      break;
    }

    case TRIGGER_STORE_PICKUP_ENABLE: {
      const {status} = action;
      state.isAutoEnableStorePickup = status;
      break;
    }

    case ADD_STORE_PICKUP_LOCATION_START: {
      state.loadingAddStorePickupLocation = true;
      break;
    }
    case ADD_STORE_PICKUP_LOCATION_SUCCESS: {
      const {data} = action;

      state.storePickupLocations = [...state.storePickupLocations, data];
      state.newStorePickupLocation = initialState.newStorePickupLocation;
      state.loadingAddStorePickupLocation = false;
      break;
    }
    case ADD_STORE_PICKUP_LOCATION_FAILED: {
      state.loadingAddStorePickupLocation = false;
      break;
    }
    case UPDATE_STORE_PICKUP_LOCATION_START: {
      state.loadingUpdateAddStorePickupLocation = true;
      break;
    }
    case UPDATE_STORE_PICKUP_LOCATION_SUCCESS: {
      const {data, data: {place_id}} = action;

      state.storePickupLocations = state.storePickupLocations.map((location) => {
        return location.place_id === place_id ? data : location;
      });
      state.loadingUpdateAddStorePickupLocation = false;
      break;
    }
    case UPDATE_STORE_PICKUP_LOCATION_FAILED: {
      state.loadingUpdateAddStorePickupLocation = false;
      break;
    }
    case GET_STORE_PICKUP_CONFIG_START: {
      state.loadingStorePickupConfig = true;
      break;
    }
    case GET_STORE_PICKUP_CONFIG_SUCCESS: {
      const {data} = action;

      state.isStorePickupEnable = data.config[0].value;
      state.loadingStorePickupConfig = false;
      break;
    }
    case GET_STORE_PICKUP_CONFIG_FAILED: {
      state.loadingStorePickupConfig = false;
      break;
    }
    case UPDATE_STORE_PICKUP_CONFIG_START: {
      state.loadingStorePickupConfig = true;
      break;
    }
    case UPDATE_STORE_PICKUP_CONFIG_SUCCESS: {
      const {data: {config}} = action;

      state.isStorePickupEnable = config[0].value;
      state.isAutoEnableStorePickup = false;
      state.loadingStorePickupConfig = false;
      break;
    }
    case UPDATE_STORE_PICKUP_CONFIG_FAILED: {
      state.loadingStorePickupConfig = false;
      state.isAutoEnableStorePickup = false;
      break;
    }
    case CANCEL_ADD_STORE_PICKUP_LOCATION: {
      state.newStorePickupLocation = initialState.newStorePickupLocation;
      break;
    }
    case CHANGE_ACTIVE_STORE_SUCCESS: {
      state.storePickupLocations = [];

      break;
    }
    default:
      break;
  }
}, initialState);

export default formReducer;
